export enum UserImageAreaOverlayStyle {
  GREY = 'grey',
  LIGHT_BLUE = 'lightBlue',
  DARK_BLUE = 'darkBlue',
}
